<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover shadow"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="row">
                <div class="col-4">
                  <h4 class="card-title">Delivery Return (Slitting Coil)</h4>
                </div>
                <div class="col-4">
                </div>
                <div class="col-4">
                  <button type="submit" class="btn btn-sm btn-secondary btn-fill float-right" @click="filter()">
                    Filter
                  </button>
                  <button type="submit" class="btn btn-sm btn-info btn-fill float-right mr-2" @click="create()">
                    Add New
                  </button>
                </div>
              </div>
            </template>
            <div class="scroll">
              <table class="table">
                <thead>
                  <slot name="columns">
                    <tr style="background-color: #F0F8FF;">
                      <th>CLIENT / OWNER</th>
                      <th>SURAT JALAN NO</th>
                      <th>DATE</th>
                      <th>WEIGHT</th>
                      <th>QTY</th>
                      <th></th>
                      <th></th>
                      <th style="display: none" ></th>
                    </tr>
                  </slot>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td style="font-size: 13px;">{{row.client_name}}</td>
                    <td style="font-size: 13px;">
                      <label class="badge badge-info" style="cursor: pointer;" @click="detailDelivery(row.packing_list_no)">{{row.packing_list_no}}</label>
                    </td>
                    <td style="font-size: 13px;">{{ moment(row.packing_date).locale('id').format('L') }}</td>
                    <td style="font-size: 13px;">{{convertRp(row.weight)}}</td>
                    <td style="font-size: 13px;">{{convertRp(row.qty)}}</td>
                    <td>
                      <i class="fa fa-edit" aria-hidden="true" style="cursor: pointer;" @click="edit(row.id)" title="Edit"></i>
                    </td>
                    <td>
                      <i class="fa fa-trash-o" aria-hidden="true" title="Hapus" style="cursor: pointer;" @click="remove(row.id)"></i>
                    </td>
                    <td style="display: none" ></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <template slot="footer">
              <div class="float-left">TOTAL : {{table.data.length}}, TOTAL WEIGHT : {{ convertRp(totalWeight) }} </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" v-model="pagination.default" @input="changePage"></base-pagination>
              </div>
            </template>
          </card>
        </div>

        <!-- MODAL CREATE -->
        <div>
           <modal :show.sync="form.show">
             <template slot="header">
                <h5 class="modal-title" id="exampleModalLabel">{{form.title}}</h5>
             </template>
             <div>
              <div class="form-group">
                <label>Client / Owner</label><br>
                <autocomplete
                  ref="autocompleteClient"
                  :url="apiUrl+'client/find-client'"
                  :customHeaders="{ Authorization: tokenApi }"
                  anchor="client_name"
                  label="client_code"
                  :on-select="getData"
                  placeholder="Choose Client / Owner"
                  :min="1"
                  :process="processJSON"
                  :classes="{ input: 'form-control', list: 'list', item: 'data-list-item' }"
                  >
                </autocomplete>
              </div>
              <base-input type="text"
                    label="Surat Jalan No"
                    placeholder="Surat Jalan No"
                    v-model="deliveryData.packing_list_no">
              </base-input>
              <base-input type="date"
                    label="Date"
                    placeholder="Date"
                    v-model="deliveryData.packing_date">
              </base-input>
             </div>
             <template slot="footer">
                <button type="secondary" class="btn btn-sm btn-secondary btn-fill mr-4" @click="form.show = false">Close</button>
                <button type="primary" class="btn btn-sm btn-info btn-fill" @click="save()" :disabled="onLoading">
                    <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
                    <span v-else>
                        <span>Save</span>
                    </span>
                </button>
             </template>
           </modal>
        </div>

        <!-- MODAL FILTER -->
        <div>
           <modal :show.sync="formFilter.show">
             <template slot="header">
                <h5 class="modal-title" id="exampleModalLabel">{{formFilter.title}}</h5>
             </template>
             <div>
              <div class="form-group">
                <label>Client / Owner</label><br>
                <autocomplete
                  ref="autocompleteFilterClient"
                  :url="apiUrl+'client/find-client'"
                  :customHeaders="{ Authorization: tokenApi }"
                  anchor="client_name"
                  label="client_code"
                  :on-select="getDataFilterClient"
                  placeholder="Choose Client / Owner"
                  :min="1"
                  :process="processJSON"
                  :classes="{ input: 'form-control', list: 'list', item: 'data-list-item' }"
                  >
                </autocomplete>
              </div>
              <base-input type="text"
                    label="Surat Jalan No"
                    placeholder="Surat Jalan No"
                    v-model="search.packing_list_no">
              </base-input>
              <small class="d-block text-uppercase font-weight-bold mb-3">Date range</small>
              <div class="input-daterange datepicker row align-items-center">
                  <div class="col">
                      <base-input addon-left-icon="ni ni-calendar-grid-58">
                          <flat-picker slot-scope="{focus, blur}"
                                       @on-open="focus"
                                       @on-close="blur"
                                       :config="{allowInput: true, mode: 'range',}"
                                       class="form-control datepicker"
                                       v-model="search.date">
                          </flat-picker>
                      </base-input>
                  </div>
              </div>
             </div>
             <template slot="footer">
                 <button type="secondary" class="btn btn-sm btn-secondary btn-fill mr-4" @click="formFilter.show = false">Close</button>
                 <button type="primary" class="btn btn-sm btn-info btn-fill" @click="get(), formFilter.show = false">Filter</button>
             </template>
           </modal>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import Card from '@/components/Cards/Card.vue'
  import Modal from '@/components/Modal.vue'
  import config from '@/configs/config';
  import Api from '@/helpers/api';
  import delivery from '@/services/delivery.service';
  import Autocomplete from 'vue2-autocomplete-js'
  require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css')
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  var moment = require('moment');

  export default {
    name: 'DeliveryReturnSlit',
    components: {
      Card,
      Modal,
      Autocomplete,
      flatPicker,
    },
    data () {
      return {
        moment:moment,
        pagination: {
          page_count: '',
          default: 1,
          page: '',
        },
        onLoading: false,
        table: {
          data: []
        },
        form: {
            add: true,
            title: "Add Data",
            show: false
        },
        formFilter: {
          add: true,
          title: "Filter",
          show: false
        },
        deliveryData: {},
        totalWeight: '',
        storageUrl : config.storageUrl,
        search: {
          client_name: '',
          packing_list_no: '',
          date: '',
          deliv_type: 'RETURN SLIT',
        },
        apiUrl :config.apiUrl,
        tokenApi : '',
      }
    },
    mounted(){
      this.get();
      this.tokenApi = 'Bearer '+localStorage.getItem('token');
    },
    activated(){
      this.get();
    },
    methods: {
      get(param){
        let context = this;
        Api(context, delivery.index({client_name: context.search.client_name, packing_list_no: context.search.packing_list_no, date: context.search.date, deliv_type: context.search.deliv_type, page: context.pagination.page})).onSuccess(function(response) {
            context.table.data            = response.data.data.data.data;
            context.pagination.page_count = response.data.data.data.last_page;
            context.totalWeight           = response.data.data.totalWeight;
        }).onError(function(error) {
            if (error.response.status == 404) {
                context.table.data = [];
            }
        })
        .call()
      },
      filter() {
        this.formFilter.add   = true;
        this.formFilter.show  = true;
        this.formFilter.title = "Filter";
        this.pagination.page  = 1 ;
      },
      create() {
          this.form.add     = true;
          this.form.show    = true;
          this.form.title   = "Add Data";
          this.deliveryData = {}
          this.defaultDate()
          this.$refs.autocompleteClient.clearInput()
          this.onLoading = false
          this.generateDelivNo()
      },
      generateDelivNo(){
          let context = this;
          Api(context, delivery.generateDeliveryNumber({type_sj: '-BCK-RTS-'})).onSuccess(function(response) {
              context.deliveryData.packing_list_no = response.data;
              context.$forceUpdate();
          })
          .call()
      },
      edit(id) {
        let context = this;
        Api(context, delivery.show(id)).onSuccess(function(response) {
            context.deliveryData = response.data.data[0];
            context.form.show    = true;
            context.form.title   = 'Edit Data';
            context.$refs.autocompleteClient.setValue(response.data.data[0].client_name)
        })
        .call()
      },
      save(){
        let api = null;
        let context = this;
        let formData = new FormData();
        this.onLoading = true;

        if (this.deliveryData.client_name != undefined && this.deliveryData.packing_list_no != undefined && this.deliveryData.packing_date != undefined) {
          formData.append('client_name', this.deliveryData.client_name);
          formData.append('packing_list_no', this.deliveryData.packing_list_no);
          formData.append('packing_date', this.deliveryData.packing_date);
        }else{
          this.onLoading = false;
          return alert('Client, Surat Jalan No & Date Wajib Di Isi')
        }

        if (context.form.title == 'Add Data') {
            api = Api(context, delivery.createReturnSlit(formData));
        } else {
            api = Api(context, delivery.updateReturnSlit(this.deliveryData.id, formData));
        }
        api.onSuccess(function(response) {
            context.get();
            context.form.show = false;
            context.notifyVue((context.form.title === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'top', 'right', 'info')
        }).onError(function(error) {
            context.notifyVue((context.form.title === 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update' , 'top', 'right', 'danger')
        }).onFinish(function() {
            context.onLoading = false
        })
        .call();
      },
      remove(id) {
        var r = confirm("Anda yakin ingin menghapus data ini ? Coil yang sudah di-retur lewat SJ ini akan dikembalikan ke status semula.");
        if (r == true) {
          let context = this;

          Api(context, delivery.deleteReturnSlit(id)).onSuccess(function(response) {
              context.get();
              context.notifyVue('Data Berhasil di Hapus', 'top', 'right', 'info')
          }).call();
        }
      },
      detailDelivery(packing_list_no){
        this.$router.push('/detail-delivery-return-slit/'+packing_list_no)
      },
      notifyVue(message, verticalAlign, horizontalAlign, type) {
        this.$notifications.notify(
        {
            message: message,
            icon: 'nc-icon nc-notification-70',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
        })
      },
      convertRp(bilangan) {
        if (bilangan) {
          var number_string = bilangan.toString(),
              sisa    = number_string.length % 3,
              rupiah  = number_string.substr(0, sisa),
              ribuan  = number_string.substr(sisa).match(/\d{3}/g);

          if(ribuan){
            var separator = sisa ? '.' : '';
            rupiah += separator + ribuan.join('.');
            return rupiah
          }else{
            return bilangan
          }
        }
      },
      changePage(page){
        this.pagination.page = page;
        this.get();
      },
      defaultDate(){
        var date  = new Date();
        var day   = ("0" + date.getDate()).slice(-2);
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var today = date.getFullYear() + "-" + (month) + "-" + (day);

        this.deliveryData.packing_date = today
      },

      // ================= Autocomplete ============
      getData(obj){
        this.deliveryData.client_name = obj.client_name;
      },
      getDataFilterClient(obj){
        this.search.client_name = obj.client_name;
      },
      processJSON(json) {
        return json.data
      },
    }
  }
</script>
<style lang='scss' scoped>
  @import "@/assets/scss/light-bootstrap-dashboard.scss";
</style>
